export enum Routes {
  ROOT = "/",
}
